import {
  Component,
  HostListener,
  Inject,
  PLATFORM_ID
} from '@angular/core';
import {FormControl, FormGroup} from "@angular/forms";
import {RECOVER_LOST_PASSWORD_ROUTE} from "src/app/app-routing.module";
import {ActivatedRoute, Router} from "@angular/router";
import {email, max_length_50, required} from '@utility';
import {AuthenticationService} from "@services";
import {LoginRequest} from "@model";
import {isPlatformBrowser} from "@angular/common";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})

export class LoginComponent {

  loginComponentState: LoginComponentState = LoginComponentState.INITIAL;
  loginComponentStateType = LoginComponentState;
  googleSigninButton: number = 400;
  public currentWindowWidth: number = 0;

  inputForm: FormGroup<{ password: FormControl<string | null>; email: FormControl<string | null> }> = new FormGroup({
    email: new FormControl('', [
        required,
        email,
        max_length_50
      ]
    ),
    password: new FormControl('', [
      required,
    ]),
  });

  @HostListener('window:resize')
  onResize(): void {
    this.currentWindowWidth = window.innerWidth
  }

  constructor(private router: Router, private route: ActivatedRoute, private authService: AuthenticationService,
              @Inject(PLATFORM_ID) private platformId: Object) {
    if (isPlatformBrowser(this.platformId)) {
      this.currentWindowWidth = window.innerWidth;
    }
  }

  onSubmit(): void {
    if (!this.inputForm.valid) {
      for (const control in this.inputForm.controls) {
        this.inputForm.get(control)?.markAsTouched();
      }
      return;
    }
    this.authService.login(new LoginRequest(this.inputForm.value.email, this.inputForm.value.password), () => {
      this.loginComponentState = LoginComponentState.ERROR;
    });
    this.inputForm.reset();
  }

  goToRecoverPasswordPage(): void {
    this.router.navigate([RECOVER_LOST_PASSWORD_ROUTE]);
  }

  onFacebookLogin(): void {
    this.authService.facebookSignIn();
  }
}

enum LoginComponentState {
  INITIAL,
  ERROR,
}
